import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./SecretChartEdit.css";
import { formatDate } from "../../../../../components/Util/DateFormat";
import axios from "axios";
import Swal from "sweetalert2";
import { getServerBaseUrl } from "../../../../../utils/portConfig";
import Editor from "../../../../../components/Dashboard/Editor";

function SecretChartEdit({ patientData, chkSecretMode, sData, secretDate }) {
  // 초기 비밀 차트 데이터
  const initialSecretData = {
    id: "",
    patientId: "",
    comments: "",
  };

  // State 변수 선언
  const [patientId, setPatientId] = useState("");
  const [secretData, setSecretData] = useState({ ...initialSecretData });
  const navigate = useNavigate();

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1`;
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userid");

  // 에디터 ref 선언
  const editorRef = useRef(null);

  // 환자 데이터가 변경될 때 실행되는 useEffect
  useEffect(() => {
    if (patientData) {
      setPatientId(patientData !== null ? patientData.id : null);
      setSecretData({ ...initialSecretData });
    }
  }, [patientData]);

  // 환자 ID가 변경될 때 실행되는 useEffect
  useEffect(() => {
    if (patientId && chkSecretMode === "수정") {
      setSecretData({
        id: sData.id || "",
        patientId: patientId,
        comments: sData.comments || "",
      });
    } else if (patientId && chkSecretMode === "등록") {
      setSecretData({ ...initialSecretData });
    }
  }, [patientId, sData]);

  // 비밀차트 - 저장,수정(2중요소) 버튼
  const secretSaveChartButton = () => {
    // 저장 시점에 현재 에디터 내용을 가져와서 저장
    let updateContents = "";

    if (editorRef.current) {
      const html = editorRef.current.getHTML();
      updateContents = html;
    }

    secretData.patientId = patientId;
    if (updateContents === "" || updateContents === "<p><br></p>") {
      showWarningAlert("차트 코멘트를 입력해 주세요.");
      return;
    }

    if (chkSecretMode === "등록") {
      console.log("create");
      createSecretChart(updateContents);
    } else if (chkSecretMode === "수정") {
      console.log("update");
      updateSecretChart(updateContents);
    }
  };

  // 비밀차트 - 취소 버튼
  const secretCancelChartButton = () => {
    navigate("/", { state: { gotoEditPage: "빈칸" } });
  };

  // 비밀 차트 생성
  const createSecretChart = (updateContents) => {
    const formData = new FormData();
    formData.append("comments", updateContents);
    axios
      .post(`${API_SERVER_URL}/schart/${patientId}/create/${userId}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } })
      .then((response) => {
        if (response.status === 201) {
          showSuccessAlert("차트가 등록되었습니다.");
          setSecretData({ ...initialSecretData });
          navigate("/", { state: { gotoEditPage: "빈칸" } });
        } else {
          showErrorAlert("실패", "차트 등록 실패. 다시 시도해주세요.");
        }
      })
      .catch((error) => {
        console.error("Error creating chart", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            showErrorAlert("차트 등록 오류", responseData);
          } else {
            showErrorAlert("서버 응답 오류", `서버 응답 오류: ${error.response.status}`);
          }
        } else {
          showErrorAlert("서버 응답이 없습니다.", "서버 응답이 없습니다.");
        }
      });
  };

  // 비밀 차트 수정 함수
  const updateSecretChart = (updateContents) => {
    const formData = new FormData();
    formData.append("comments", updateContents);
    axios
      .put(`${API_SERVER_URL}/schart/${secretData.id}/update/${userId}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } })
      .then((response) => {
        if (response.status === 200) {
          showSuccessAlert("차트가 수정되었습니다.");
          setSecretData({ ...initialSecretData });
          navigate("/", { state: { gotoEditPage: "빈칸" } });
        } else {
          showErrorAlert("실패", "차트 수정 실패. 다시 시도해주세요.");
        }
      })
      .catch((error) => {
        console.error("Error updating chart", error);
        showErrorAlert("오류", "차트 수정 실패. 다시 시도해주세요.");
      });
  };

  /* 메세지 공통 함수*/
  const showSuccessAlert = (text) => {
    Swal.fire({
      icon: "success",
      title: "성공",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const showErrorAlert = (title, text) => {
    Swal.fire({
      icon: "error",
      title: title,
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const showWarningAlert = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  return (
    <div style={{ padding: "2px", width: "100%", height: "100%" }}>
      <div className="right-group">
        <div className="content-select-container">
          <label>환자 진단 날짜: {chkSecretMode === "등록" ? <span>{formatDate(new Date()).replace(".", "-").replace(".", "-")}</span> : <span>{secretDate}</span>}</label>
        </div>
        <div className="secret-content-quill-container" style={{ fontWeight: "400" }}>
          <Editor ref={editorRef} readOnly={false} initialHTML={secretData.comments} />
        </div>
        <div className="content-button-container">
          <button className="secret-save-button" onClick={secretSaveChartButton}>
            저장
          </button>
          <button className="secret-delete-button" onClick={secretCancelChartButton}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
}

export default SecretChartEdit;
